import { _t } from "core/language";
import React from "react";

interface MainNodataProps {
  loading: boolean;
  data: any;
  text: string;
}
const MainNodata: React.FC<MainNodataProps> = ({ loading, data, text }) => {
  return (
    <div className="w-full">
      {!loading && data.length === 0 && (
        <p className="text-[13px] w-full text-center text-neutral-500 mt-1">
          {_t(text)}
        </p>
      )}
    </div>
  );
};

export default MainNodata;
